module.exports = __webpack_public_path__ + "media/apps/gif-android-34-firstframe-0d9086ba.jpg";